import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { SHOW_MTC_MENUS } from '../featureFlags';

/**
 * Renders children only when REACT_APP_SHOW_MTC_MENUS=true at build time.
 * Otherwise shows a friendly "feature disabled" page so developers and
 * operators can tell the difference between a 404 and an intentionally
 * gated tender feature.
 */
function MtcGate({ children }) {
  if (SHOW_MTC_MENUS) return children;
  return (
    <div className="page-container">
      <div className="alert-banner alert-banner--warning" style={{ marginTop: '2rem' }}>
        <span className="alert-banner__body">
          <FaInfoCircle />{' '}
          This feature is part of the MTC25-26-O AML compliance bundle and is
          not enabled on this deployment. Set{' '}
          <code>REACT_APP_SHOW_MTC_MENUS=true</code> in the client environment
          and restart <code>npm start</code> to enable it.
        </span>
      </div>
    </div>
  );
}

export default MtcGate;
